var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLearningEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12045_34833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5391 12.9805C18.8594 13.543 19.0977 14.1289 19.2539 14.7383C19.4102 15.3477 19.4922 15.9766 19.5 16.625V17.832L12 21.5938L4.5 17.832C4.5 17.3633 4.50391 16.9258 4.51172 16.5195C4.51953 16.1133 4.55469 15.7188 4.61719 15.3359C4.67969 14.9531 4.77344 14.5703 4.89844 14.1875C5.02344 13.8047 5.21094 13.4023 5.46094 12.9805L3 11.75V18.6289C3.22656 18.707 3.42969 18.8164 3.60938 18.957C3.78906 19.0977 3.94922 19.2617 4.08984 19.4492C4.23047 19.6367 4.33203 19.8398 4.39453 20.0586C4.45703 20.2773 4.49219 20.5078 4.5 20.75V24.5H0V20.75C0 20.5156 0.0351562 20.2891 0.105469 20.0703C0.175781 19.8516 0.277344 19.6445 0.410156 19.4492C0.542969 19.2539 0.699219 19.0898 0.878906 18.957C1.05859 18.8242 1.26562 18.7148 1.5 18.6289V11L0 10.25L12 4.25L24 10.25L18.5391 12.9805ZM3 20.75C3 20.5469 2.92578 20.3711 2.77734 20.2227C2.62891 20.0742 2.45313 20 2.25 20C2.04687 20 1.87109 20.0742 1.72266 20.2227C1.57422 20.3711 1.5 20.5469 1.5 20.75V23H3V20.75ZM3.35156 10.25L12 14.5742L20.6484 10.25L12 5.92578L3.35156 10.25ZM18 16.9062C18 16.3047 17.9414 15.7461 17.8242 15.2305C17.707 14.7148 17.5 14.1875 17.2031 13.6484L12 16.25L6.79688 13.6484C6.53906 14.1016 6.34375 14.5781 6.21094 15.0781C6.07813 15.5781 6.00781 16.0938 6 16.625V16.9062L12 19.9062L18 16.9062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12045_34833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLearningEducation);
export default __webpack_public_path__ + "static/media/icon-learning-education.c03f4bed.svg";
export { ForwardRef as ReactComponent };